<template>
    <v-container>
        <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-btn outlined color="grey darken-2" @click="addApp">新增</v-btn>
            <v-dialog v-model="editDailog" max-width="500px" persistent>
                 <v-card>
                      
                        <v-card-title >应用列表</v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="应用名称"
                                            v-model="editedItem.app_name"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="4">
                                        <v-select
                                            label="应用平台"
                                            v-model="editedItem.platform"
                                            :items="['ANDROID','IOS']"
                                        ></v-select>
                                    </v-col>
                                                
                                    <v-col></v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-text-field
                                            label="应用包名"
                                            v-model="editedItem.package_name"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-text-field
                                            label="本地加密KEY"
                                            v-model="editedItem.local_xor"
                                        ></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="2">
                                        <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="generateKeyLocal"
                                            >生成</v-btn>
                           
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="8">
                                        <v-text-field
                                            label="服务器加密KEY"
                                            v-model="editedItem.server_xor"
                                        ></v-text-field>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="2">
                                        <v-btn
                                            color="blue darken-1"
                                            text
                                            @click="generateKeyServer"
                                            >生成</v-btn>
                           
                                    </v-col>
                                </v-row>
 
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="DailogCancel"
                            >
                                取消
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="DailogSave"
                            >
                                保存
                            </v-btn>
                        </v-card-actions>
                    </v-card>


             </v-dialog>
             <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                 

                    <v-card-title class="text-h5">确认要删除{{this.editedItem.package_name}}?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">取消</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">确认</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
        </v-toolbar>
      <v-card class="ma-3">
        <v-data-table
          :headers="headers"
          :items = "items"
  
          :options.sync="options"
          :server-items-length="serverLength"
          :loading="loading"
          loading-text="加载中..."
          :search="search"
          class="elevation-2"
        >
        <template v-slot:item.modify_time="{ item }">
          <v-chip small>
            {{ getTimeStrFromTimestamp(item.modify_time) }}
          </v-chip>
        </template>
  
        <template v-slot:item.actions="{ item }">
           <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
           >
                mdi-pencil
           </v-icon>
           <v-icon
                small
                @click="deleteItem(item)"
           >
                mdi-delete
           </v-icon>
       </template>
  
        </v-data-table>
      </v-card>
     
    </v-container>
  </template>
  
  <script>
    import axios from 'axios'
    import moment from 'moment';
    import RegionUtils from '../utils/regionUtils';
  
    export default {
      name: 'DataServer',
      components: {
        
      },
      data: function(){
        return {
           headers: [
                  {
                      text: "ID",
                      align: "center",
                      sortable: false,
                      value: "id",
                      width: "140px",
  
                  },
                  {
                      text: "应用包名",
                      align: "center",
                      sortable: false,
                      value: "package_name",
                      width: "140px",
  
                  },
                   {
                      text: "应用名称",
                      align: "center",
                      sortable: false,
                      value: "app_name",
                      width: "10%",
  
                  },
                  {
                      text: "平台",
                      align: "center",
                      value: "platform",
                      width: "12%",
                  },
                  {
                     text: "Server加密Key",
                     align: "center",
                     value: "server_xor", 
                     width: "10%",
                  },
                  {
                      text: "本地加密Key",
                      align: "center",
                      value: "local_xor",
                      width: "10%",
                  },
                  {
                      text: "存档数",
                      align: "center",
                      value: "count",
                      width: "5%",
                  },
                  {
                      text: "更新时间",
                      align: "center",
                      value: "modify_time",
                      width: "100px",
                  },
                  {
                      text: "操作",
                      align: "center",
                      value: "actions",
                      width: "5%",
                  }
                  // {
                  //     text: "cti",
                  //     align: "center",
                  //     value: "ctr",
                  //     width: "10%",
                  // },
                  
  
              ],
          items: [],
          search: "",
          apps: [],
          editDailog:false,
          spendGt: 0,
          selectedApps: [],
          editedItem:{},
          countries: RegionUtils.getAllContries(),
          selectedCountries:[],
          isModifying: false,
          dialogDelete:false,
          adPlatforms: [],
          selectedAdPlatforms: [],
          serverLength: 0,
          loading: true,
          spendGtOldVal: 0,
          options:{},
          dateRange:[moment().subtract(7,'d'),moment()],
          tab: null,
          libraryList: null,
          page: 0,
          step: 20,
        }
      },
      watch: {
          options:{
              handler(){
                  this.reloadData();
              },
              deep: true,
          },
          dateRange:{
              handler(){
                  this.reloadData();
                  this.getAdPlatforms();
                  this.getAllApps();
                  this.getCountries();
              },
              deep: true,
          },
          selectedApps:{
              handler(){
                  this.reloadData();
                  this.getAdPlatforms();
                  this.getCountries();
              },
              deep: true,
          },
          selectedCountries:{
              handler(){
                  this.reloadData();
                  this.getAdPlatforms();
                  this.getAllApps();
  
              },
              deep: true,
          },
          selectedAdPlatforms:{
              handler(){
                  this.reloadData();
                  this.getCountries();
                  this.getAllApps();
              },
              deep: true,
          },
  
      },
      computed:{
          allAppSelected: function(){
              return this.selectedApps.length === this.apps.length;
          },
          someAppSelected: function(){
              return this.selectedApps.length > 0 && !this.allAppSelected;
          },
          allCountrySelected: function(){
              return this.selectedCountries.length === this.countries.length;
          },
          someCountrySelected: function(){
              return this.selectedCountries.length > 0 && !this.allCountrySelected;
          },
          allAdPlatformSelected: function(){
              console.log(this.selectedAdPlatforms);
              return this.selectedAdPlatforms.length === this.adPlatforms.length;
          },
          someAdPlatformSelected: function(){
              return this.selectedAdPlatforms.length > 0 && !this.allAdPlatformSelected;
          },
          icon_app: function() {
            if (this.allAppSelected) return 'mdi-close-box'
            if (this.someAppSelected) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
          },
          icon_country: function() {
            if (this.allCountrySelected) return 'mdi-close-box'
            if (this.someCountrySelected) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
          },
          icon_adPlatform: function() {
            if (this.allAdPlatformSelected) return 'mdi-close-box'
            if (this.someAdPlatformSelected) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
          },
      },
      mounted: function(){
        axios.get('/admin/api/listApp').then(res => {
          this.apps = res.data.data;
        });
        this.reloadData();
        
      },
      methods: {
        editItem: function(item){
            var index = this.items.indexOf(item);
            if (index !== -1){
                this.isModifying = true;
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            }else{
                this.isModifying = false;
            }
           
        },

        closeDelete: function(){
            this.dialogDelete = false;
        },
        
        deleteItem: function(item){
            console.log("delete item clicked");
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemConfirm:function(){
            var vm = this;
            var formData = new FormData();
            formData.append("id", this.editedItem.id);
            axios.post('/api/admin/delApp', formData, {
                headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response){              
                console.log(response);
                vm.clearEditedItem();
                vm.isModifying = false;
                vm.dialogDelete = false;
                vm.reloadData();
            }).catch(function(error){
                console.log(error);
                vm.reloadData();
            });
        },

        spendGtStartChange: function(value){
          console.log(value);
          this.spendGtOldVal = value;
        },
        addApp: function(){
            this.clearEditedItem();
            this.editDailog = true;
        },
        spendGtEndChange: function(value){
          if (value !== this.spendGtOldVal){
            console.log("change");
            this.spendGt = value;
            this.reloadData();
          }else{
            console.log("no change");
          }
        },
        handleDateRangeChange: function(values){
          console.log(values);
          this.dateRange = values;
        },

        clearEditedItem: function(){
            this.isModifying = false;
            this.editedItem = {
                app_name: '',
                package_name: '',
                platform: '',
                server_xor: '',
                local_xor: '',
                record_cnt: 0,
                modify_time: 0,
            }
        },

        getTimeStrFromTimestamp(timestamp){
            var s = new Date(timestamp*1000)
            return s.toLocaleString("zh-CN")
        },

        saveAppToServer: function(){
            var vm = this;
            var params = new URLSearchParams({
                app_name: vm.editedItem.app_name,
                package_name: vm.editedItem.package_name,
                platform: vm.editedItem.platform,
                server_xor: vm.editedItem.server_xor,
                local_xor: vm.editedItem.local_xor,
            });
            axios.post('/api/admin/addApp', params).then(function(response){
                if(response.data.status == 0){
                    vm.$emit("showSnackMessage", "保存成功");
                    vm.editDailog = false;
                    vm.reloadData();
                }else{
                    vm.$emit("showSnackMessage", "保存失败", true);
                }
            });
        },

        DailogSave: function(){
            this.saveAppToServer();
            // if(!this.isModifying){
            //     this.addEvent();
            // }else{
            //     this.modCol();
            // }
            
        },
        DailogCancel: function(){
            this.editDialog = false;
            this.clearEditedItem();
        },

        generateKey: function() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+[]{}|;:,.<>?=';
            let result = '';
            for (let i = 0; i < 32; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },

        generateKeyLocal:function(){
            var key = this.generateKey();
            this.editedItem.local_xor = key;
        },

        generateKeyServer:function(){
            var key = this.generateKey();
            this.editedItem.server_xor = key;
        },
        
        
  
        reloadData: function(){
              const { page, itemsPerPage } = this.options
              console.log(page)
              console.log(itemsPerPage)
              var vm = this;
              vm.loading = true;
              var params = new URLSearchParams({
                  page: page-1,
                  step: itemsPerPage,
                //   sort_by: sortBy,
                //   sort_desc: sortDesc,
                //   staff_creative: vm.staff_creative,
                //   staff_op: vm.staff_op,
                //   ad_platform: vm.selectedAdPlatforms.join(","),
                //   start_date: vm.dateRange[0].format('YYYYMMDD'),
                //   end_date: vm.dateRange[1].format('YYYYMMDD'),
                //   spend_gt: vm.spendGt,
                //   apps: vm.selectedApps.join(","),
                //   countries: vm.selectedCountries.join(","),
              });
              var queryStr = params.toString();
              axios.get('/api/admin/listApp?'+queryStr)
                  .then(function(response){
                      vm.items = response.data.data.items;
                      vm.loading=false;
                      vm.serverLength = response.data.data.total;
                      
              });
              // axios.get("/admin/api/listCollection")
              //     .then(function(response){
              //         if(response.data.status == 0){
              //             vm.collectionCandiate = response.data.data;
              //         }
              // });
          },
          toggleSelectAllApps: function(){
            this.$nextTick(()=>{
              if(this.allAppSelected){
                this.selectedApps = [];
              }else{
                this.selectedApps = this.apps;
              }
            })
          },
          toggleSelectAllCountries: function(){
            this.$nextTick(()=>{
              if(this.allCountrySelected){
                this.selectedCountries = [];
              }else{
                this.selectedCountries = this.countries;
              }
            })
          },
          toggleSelectAllAdPlatforms: function(){
            this.$nextTick(()=>{
              if(this.allAdPlatformSelected){
                this.selectedAdPlatforms = [];
              }else{
                this.selectedAdPlatforms = this.adPlatforms;
              }
            })
          },
          
      }
    }
  </script>
  <style>
  </style>
  